import { AppFlavor, PerCountryConfig } from 'types';

type SharedImage = "logo" | "footerBackground";

type TranslatedImage = "card" | "phone" | "phoneCropped" | "joinClub";

type FlavorBasedConfig = Record<AppFlavor, string>;

type LinksConfig = PerCountryConfig<FlavorBasedConfig>;

export const STORE: LinksConfig = {
  cz: {
    FITANU: "https://fitanu.com/pl/",
    MARTES: "https://martessport.eu/cz/",
  },
  ro: {
    FITANU: "https://fitanu.com/pl/",
    MARTES: "https://martessport.eu/ro/",
  },
  pl: {
    FITANU: "https://fitanu.com/pl/",
    MARTES: "https://sklepmartes.pl/",
  },
};

export const TERMS: LinksConfig = {
  cz: {
    FITANU: "https://fitanu.com/pl/regulamin",
    MARTES: "https://martessport.eu/cz/poriadok-klubu-martes-sport",
  },
  ro: {
    FITANU: "https://fitanu.com/pl/regulamin",
    MARTES: "https://martessport.eu/ro/regulamentul-clubuli-martes-sport",
  },
  pl: {
    FITANU: "https://fitanu.com/pl/regulamin",
    MARTES:
      "https://www.sklepmartes.pl/content/92-regulamin-klubu-martes-sport",
  },
};

export const PRIVACY_POLICY: LinksConfig = {
  cz: {
    FITANU: "https://fitanu.com/pl/polityka-prywatnosci-klub-fitanu",
    MARTES: "https://martessport.eu/cz/ochrana-osobnich-udaju",
  },
  ro: {
    FITANU: "https://fitanu.com/pl/polityka-prywatnosci-klub-fitanu",
    MARTES: "https://martessport.eu/ro/politica-de-confidentialitate",
  },
  pl: {
    FITANU: "https://fitanu.com/pl/polityka-prywatnosci-klubu-fitanu",
    MARTES: "https://sklepmartes.pl/polityka-prywatnosci-m-club",
  },
};
